module.exports = __webpack_public_path__ + "media/images/destroy-e4efcb06407fde1458a58bec214e33d7.svg";